"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGame = exports.Game = void 0;
var Game;
(function (Game) {
    Game["Crossplay"] = "crossplay";
    Game["Kelimelik"] = "kelimelik";
    Game["LetterLeague"] = "letter-league";
    Game["Literaki"] = "literaki";
    Game["Scrabble"] = "scrabble";
    Game["ScrabbleDuel"] = "scrabble-duel";
    Game["SuperScrabble"] = "super-scrabble";
})(Game || (exports.Game = Game = {}));
const games = Object.values(Game);
const isGame = (locale) => games.includes(locale);
exports.isGame = isGame;
